import React from "react";
import LandscapePage from "../pages/LandscapePage";
import FixedPortalPage from "../pages/FixedPortalPage";
import FlowBuilderPage from "../pages/FlowBuilderPage";
import WorkCenterPage from "../pages/WorkCenterPage";
import CarrierIntegrationsPage from "../pages/CarrierIntegrationsPage";
import LogicAppMonitorPage from "../pages/LogicAppMonitorPage";
import ImportPage from "../pages/ImportPage";
import MailRulesPage from "../pages/MailRulesPage";
import ImportOverviewPage from "../pages/ImportOverviewPage";
import AdminSettingsPage from "../pages/AdminSettingsPage";
import ComboKeyCheckerPage from "../pages/ComboKeyCheckerPage";
import ComboKeyApprovalsPage from "../pages/ComboKeyApprovalsPage";
import InternalUserManagementPage from "../pages/InternalUserManagementPage";
import IntegrationMonitorPage from "../pages/IntegrationMonitorPage";
import IntegrationCenterPage from "../pages/IntegrationCenterPage";
import QuoteAutomationPage from "../pages/QuoteAutomationPage";
import JccInkoopfacturenPage from "../pages/JccInkoopfacturenPage";

import { portalPageRegistry } from "./internalPortalPages";

export type PortalPageKey = typeof portalPageRegistry[number]["key"];

export type PortalPageDefinition = {
  key: PortalPageKey;
  label: string;
  path: string;
  component: React.ComponentType<any>;
  showInMenu: boolean;
  group: string;
  menuGroup?: string;
  adminOnly?: boolean;
  superadminOnly?: boolean;
};

const pageComponents: Record<PortalPageKey, React.ComponentType<any>> = {
  landscape: LandscapePage,
  flowBuilder: FlowBuilderPage,
  workCenter: WorkCenterPage,
  financeIntegrations: IntegrationMonitorPage,
  integrationCenter: IntegrationCenterPage,
  salesQuoteAutomation: QuoteAutomationPage,
  import: ImportOverviewPage,
  importAutomation: ImportPage,
  mailRules: MailRulesPage,
  carrierIntegrations: CarrierIntegrationsPage,
  logicAppMonitor: LogicAppMonitorPage,
  createPortal: FixedPortalPage,
  agenciesInkoopInvoices: JccInkoopfacturenPage,
  adminSettings: AdminSettingsPage,
  comboKeyChecker: ComboKeyCheckerPage,
  comboKeyApprovals: ComboKeyApprovalsPage,
  internalUserManagement: InternalUserManagementPage,
};

export const portalPages: PortalPageDefinition[] = portalPageRegistry.map((page) => ({
  ...page,
  component: pageComponents[page.key],
}));
